<mat-card class="mat-elevation-z8">
  <mat-card-content>
    <table mat-table [dataSource]="serviceRequests">
      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef>Customer</th>
        <td mat-cell *matCellDef="let element">{{ element.customer?.name }}</td>
      </ng-container>

      <ng-container matColumnDef="orderNumber">
        <th mat-header-cell *matHeaderCellDef>Order Number</th>
        <td mat-cell *matCellDef="let element">{{ element.orderNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="pickupAddress">
        <th mat-header-cell *matHeaderCellDef>Pickup Address</th>
        <td mat-cell *matCellDef="let element">
          {{ element.pickupAddress?.suburb }}
        </td>
      </ng-container>

      <ng-container matColumnDef="deliveryAddress">
        <th mat-header-cell *matHeaderCellDef>Delivery Address</th>
        <td mat-cell *matCellDef="let element">
          {{ element.deliveryAddress?.suburb }}
        </td>
      </ng-container>

      <ng-container matColumnDef="otp">
        <th mat-header-cell *matHeaderCellDef>OTP</th>
        <td mat-cell *matCellDef="let element">{{ element.otp }}</td>
      </ng-container>

      <ng-container matColumnDef="weight">
        <th mat-header-cell *matHeaderCellDef>Package Weight (kg)</th>
        <td mat-cell *matCellDef="let element">{{ element.weight }}</td>
      </ng-container>

      <ng-container matColumnDef="volume">
        <th mat-header-cell *matHeaderCellDef>Package Volume (cm³)</th>
        <td mat-cell *matCellDef="let element">{{ element.volume }}</td>
      </ng-container>

      <ng-container matColumnDef="packageCount">
        <th mat-header-cell *matHeaderCellDef>Package Count</th>
        <td mat-cell *matCellDef="let element">{{ element.packageCount }}</td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Created At</th>
        <td mat-cell *matCellDef="let element">
          {{ element.createdAt | date : "dd/MM/yyyy HH:mm" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef>Updated At</th>
        <td mat-cell *matCellDef="let element">
          {{ element.updatedAt | date : "dd/MM/yyyy HH:mm" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="utils.getServiceRequestStatusColor(element.status)"
        >
          {{ utils.getServiceRequestStatus(element.status) }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr
        mat-row
        (click)="navToServiceRequestDetails(row.id)"
        *matRowDef="let row; columns: columns"
      ></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell p-2" [attr.colspan]="columns.length">
          No Service Requests
        </td>
      </tr>
    </table>
  </mat-card-content>
</mat-card>
